import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { useSelector } from 'react-redux';
import { store, RootState } from '@/store';
import LoginScreen from '@/components/auth/LoginScreen';
import SignupScreen from '@/components/auth/SignupScreen';
import AddressDetailsForm from '@/components/profile/AddressDetailsForm';
import BankDetailsForm from '@/components/profile/BankDetailsForm';
import BasicTurfInfoForm from '@/components/turf/BasicTurfInfoForm';
import TurfAddressForm from '@/components/turf/TurfAddressForm';
import { ProfileCompletionProgress } from '@/components/profile/ProfileCompletionProgress';
import { VenueOnboardingProgress } from '@/components/turf/VenueOnboardingProgress';
import { useNavigate, useLocation } from 'react-router-dom';
import routes from "@/routes/routes.json";
import { getVendorProfile, updateVendorProfile } from '@/store/thunkMidddleware/usersMiddleware';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks'
import VendorOnboardSkeleton from '@/components/skeletons/VendorOnboardSkeleton';
import { Address, BankDetails } from '@/types/interfaceType'
import {  getStaticConfig } from '@/store/thunkMidddleware/turfMiddleware';
import Strings from '@/constants/String';
import { LogOut } from 'lucide-react';
import { forceLogout } from "@/lib/forceLogout";

type OnboardingStep = 'auth' | 'address' | 'bank' | 'turf-basic' | 'turf-address' | 'dashboard';


const VendorOnboardingProfile: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { isAuthenticated } = useAppSelector((state: RootState) => state.auth);
    const { isAddressCompleted, isBankDetailsCompleted } = useAppSelector((state: RootState) => state.profile);
    const profileState = useAppSelector(state => state.profile)
    const {staticConfigResponse} = useAppSelector(state => state.turf)

    const [currentStep, setCurrentStep] = useState<OnboardingStep>('address');

    React.useEffect(() => {
        // if (isAuthenticated) {
        //     if (!isAddressCompleted) {
        //         setCurrentStep('address');
        //     } else if (!isBankDetailsCompleted) {
        //         setCurrentStep('bank');
        //     } else {
        //         navigateToDashboard()
        //         // setCurrentStep('dashboard');
        //     }
        // } else {
        //     // navigateToLogin()
        //     // setCurrentStep('auth');
        // }
    }, [isAuthenticated, isAddressCompleted, isBankDetailsCompleted]);

    useEffect(() => {
        fetchProfile()
    }, [])

    const fetchProfile = async (token?: string) => {
        dispatch(getVendorProfile({
            callback: (profile) => {
                console.log("profile:", profile)
                if (!profile?.payload?.isAddressCompleted) {
                    setCurrentStep('address');
                } else if (!profile?.payload?.isBankDetailsCompleted) {
                    setCurrentStep('bank');
                } else if(!profile?.payload?.vendorProfileCompleted) {
                    setCurrentStep('address');
                }else{
                    navigateToDashboard()
                }
            }
        }))
    }

    const updateProfile = async (address?: Address, callback?: (res: any) => void) => {
        if (address) {
            dispatch(updateVendorProfile({
                payload: { address },
                callback: callback
            }))
        }

    }

    const updateProfileBank = async (bankDetails?: BankDetails, callback?: (res: any) => void) => {
        if (bankDetails) {
            dispatch(updateVendorProfile({
                payload: { bankDetails },
                callback: callback
            }))
        }

    }


    const navigateToDashboard = () => {
        navigate(routes.dashboard)
    }

    const goBackFromBankHandler=()=>{
        setCurrentStep("address")
    }

    const navigateToLogin = () => {
        navigate(routes.login)
    }

    useEffect(() => {
         dispatch(getStaticConfig({ pathparams: Strings.staticConfigKeys.banks }))  
      }, [])

    const renderCurrentStep = () => {

        if (profileState.vendorProfile.isLoading) {
            return <VendorOnboardSkeleton />
        } else {
            switch (currentStep) {
                case 'address':
                    return (
                        <div className="min-h-screen bg-flup-canvas flex flex-col sm:flex-row items-center">
                           <button
                                type="button"
                                onClick={() => forceLogout()}
                                className='absolute top-6 right-6 inline-flex items-center gap-2 h-9 px-3 rounded-flup-sm text-flup-ink-2 hover:bg-flup-danger-soft hover:text-flup-danger transition-colors'
                           >
                                <LogOut className='w-4 h-4' />
                                <span className='font-body text-[13px] font-semibold'>Log out</span>
                           </button>
                            
                            <ProfileCompletionProgress />
                            <div className="flex-1 flex items-center justify-center ">
                                <div className="w-full  max-w-2xl">
                                    <AddressDetailsForm onNext={() => setCurrentStep('bank')}
                                        updateProfile={updateProfile} />
                                </div>
                            </div>
                        </div>
                    );

                case 'bank':
                    return (
                        <div className="min-h-screen bg-flup-canvas flex">
                            <button
                                type="button"
                                onClick={() => forceLogout()}
                                className='absolute top-6 right-6 inline-flex items-center gap-2 h-9 px-3 rounded-flup-sm text-flup-ink-2 hover:bg-flup-danger-soft hover:text-flup-danger transition-colors'
                           >
                                <LogOut className='w-4 h-4' />
                                <span className='font-body text-[13px] font-semibold'>Log out</span>
                           </button>
                            <ProfileCompletionProgress />
                            <div className="flex-1 flex items-center justify-center p-6">
                                <div className="w-full max-w-3xl">
                                    <BankDetailsForm
                                        onNext={navigateToDashboard}
                                        onSkip={navigateToDashboard}
                                        goBack={goBackFromBankHandler}
                                        updateProfileBank={updateProfileBank}
                                    />
                                </div>
                            </div>
                        </div>
                    );

                default:
                    return null;
            }
        }
    };

    return (
        <div className='relative'>
            { renderCurrentStep()}
        </div>
    )
    
   
};
export default VendorOnboardingProfile;
